import setTransition from './setTransition';
import transitionStart from './transitionStart';
import transitionEnd from './transitionEnd';
export default {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/transition/index.js
// module id = 746
// module chunks = 169